module.exports = __webpack_public_path__ + "static/media/hc5.38313f10.png";